export default __webpack_public_path__ + "static/media/usdt_sol.17864bc8.svg";